import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from '../shared/authentication/auth-guard';

import { GerenciarLaboratorioComponent } from './gerenciar-laboratorio/gerenciar-laboratorio.component';
import { CadastroLaboratorioFormComponent } from './cadastro-laboratorio-form/cadastro-laboratorio-form.component';
import { VisualizarLaboratorioComponent } from './visualizar-laboratorio/visualizar-laboratorio.component';

const LaboratorioRoutes: Routes = [
    { path: 'gerenciar-laboratorio', component: GerenciarLaboratorioComponent, canActivate: [ AuthGuard ] },
    { path: 'cadastro-laboratorio-form/:idLaboratorio', component: CadastroLaboratorioFormComponent, canActivate: [ AuthGuard ] },
    { path: 'cadastro-laboratorio-form', component: CadastroLaboratorioFormComponent, canActivate: [ AuthGuard ] },
    { path: 'visualizar-laboratorio/:idLaboratorio', component: VisualizarLaboratorioComponent, canActivate: [ AuthGuard ] },
];

export const LaboratorioRouting = RouterModule.forChild(LaboratorioRoutes);



// WEBPACK FOOTER //
// ./src/app/components/laboratorio/laboratorio.routing.ts